import React from 'react';
import { StyleSheet } from 'react-native';

import { Logo } from '@/components/MergedLogos';
import { ds } from '@/components/lib/design.system';

const styles = StyleSheet.create({
    logoStyle: {
        alignSelf: 'center',
        width: 20,
        height: 20,
    },
});

export const ColorMatrixImage = ({ icon }: { icon: string }) => {
    return (
        <Logo
            icon={icon}
            logoSize={20}
            logoStyle={styles.logoStyle}
            secondaryColor={ds.colorValue.icon.primary}
            teamFallbackTextColor={ds.colorValue.text.primary}
            renderMode={'team'}
        />
    );
};
